"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Footer_1 = __importDefault(require("../Navigation/Footer"));
const Aside_1 = __importDefault(require("../Navigation/Aside"));
const NavBar_1 = __importDefault(require("../Navigation/NavBar"));
const classes = __importStar(require("./Layout.module.scss"));
const auth_1 = require("common/auth");
const domEvent_1 = require("common/domEvent");
const classnames_1 = __importDefault(require("classnames"));
const components_1 = require("utils/components");
const react_router_dom_1 = require("react-router-dom");
const hooks_1 = require("common/hooks");
const react_hooks_async_modal_1 = require("react-hooks-async-modal");
const error_boundary_1 = require("common/error-boundary");
const autoUpdate_1 = require("common/autoUpdate");
// eslint-disable-next-line @typescript-eslint/ban-types
const AdminLayout = ({ children, NotFoundComp, loginRoute, }) => {
    (0, hooks_1.useTracker)();
    const [asideMobileActive, setAsideMobileActive] = (0, react_1.useState)(false);
    const [collapsed, setCollapsed] = (0, react_1.useState)(false);
    const changeAsideMobileActive = (0, react_1.useCallback)((flag) => {
        document.documentElement.classList.toggle("has-aside-mobile-expanded", flag);
        setAsideMobileActive(flag);
    }, []);
    const toggleAsideMobileActive = (0, react_1.useCallback)(() => {
        changeAsideMobileActive(!asideMobileActive);
    }, [asideMobileActive]);
    (0, domEvent_1.useDomEvent)(window, ["resize", "scroll"], () => {
        changeAsideMobileActive(false);
    });
    (0, hooks_1.useModalCancel)();
    const mainRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (mainRef.current && asideMobileActive) {
            const element = mainRef.current;
            const closeHandler = () => {
                changeAsideMobileActive(false);
            };
            element.addEventListener("click", closeHandler);
            return () => {
                element.removeEventListener("click", closeHandler);
            };
        }
    }, [mainRef.current, asideMobileActive]);
    const { loading, isAdmin, user } = (0, auth_1.useAdminAuthentication)();
    const { projectId } = (0, react_router_dom_1.useParams)();
    const { projectIds, role } = user || {};
    const location = (0, react_router_dom_1.useLocation)();
    (0, react_1.useEffect)(() => {
        (0, autoUpdate_1.performUpdate)(false);
    }, [location]);
    if (loading) {
        return react_1.default.createElement(components_1.Loading, null);
    }
    if (!isAdmin) {
        return react_1.default.createElement(react_router_dom_1.Navigate, { to: loginRoute, replace: true });
    }
    if (role !== "master" && projectId && !(projectIds === null || projectIds === void 0 ? void 0 : projectIds.includes(projectId))) {
        return NotFoundComp;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(NavBar_1.default, { handleMobileToggle: toggleAsideMobileActive, asideMobileActive: asideMobileActive }),
        react_1.default.createElement("div", { onClickCapture: () => setTimeout(() => changeAsideMobileActive(false), 0) },
            react_1.default.createElement(Aside_1.default, { asideMobileActive: asideMobileActive, collapsed: collapsed, toggle: () => setCollapsed((collapsed) => !collapsed) })),
        react_1.default.createElement("div", { onClickCapture: (e) => {
                if (asideMobileActive) {
                    e.preventDefault();
                    setTimeout(() => changeAsideMobileActive(false), 0);
                }
            }, className: (0, classnames_1.default)(classes["layout"], "enableScrollbar", collapsed ? classes["collapsed"] : "") },
            react_1.default.createElement("div", null,
                react_1.default.createElement(react_hooks_async_modal_1.ModalProvider, null,
                    react_1.default.createElement(error_boundary_1.ErrorBoundary, { recovoryKey: location.key, loginRoute: loginRoute }, children))),
            react_1.default.createElement(Footer_1.default, null))));
};
exports.default = AdminLayout;
